if (!customElements.get("blogs-filter")) {
    class BlogsFiltering extends HTMLElement {
        constructor() {
            super();

            this.tags = this.querySelector('[data-filter="tags"]');
            this.articles = document.querySelectorAll(
                '[data-blog="articles"] .article'
            );

            this.filteringByTags();
        }

        onTagClick(e) {
            e.preventDefault();

            let currentTag = e.target,
                tagTitle =
                    currentTag.textContent.trim() ||
                    currentTag.innerText.trim(),
                articles = this.articles,
                articleTag,
                blogsTag;

            for (blogsTag of this.tags.children) {
                blogsTag.classList.remove("active");
            }

            if (!currentTag.parentNode.classList.contains("active"))
                currentTag.parentNode.classList.add("active");

            articles.forEach((article) => {
                articleTag = article.dataset?.articleTag.toUpperCase();

                if (currentTag.parentNode.classList.contains("all")) {
                    article.style.display = "initial";
                } else if (
                    articleTag &&
                    articleTag.toUpperCase().indexOf(tagTitle.toUpperCase()) ==
                        -1
                ) {
                    article.style.display = "none";
                } else {
                    article.style.display = "initial";
                }
            });
        }

        filteringByTags() {
            let tag,
                tags = this.tags.children;

            if (!tags.length || !this.articles.length) return;

            for (tag of tags)
                tag.addEventListener("click", this.onTagClick.bind(this));
        }
    }

    customElements.define("blogs-filter", BlogsFiltering);
}
